import { styled } from '@mui/system';
import { PerlmanGreen } from '../../theme';

export const BreadCrumbsContainer = styled('div')({
    border: '0.5px solid grey',
    borderRadius: '8px',
    display: 'block',
    backgroundColor: '#fff',
    letterSpacing: '.1px',
    marginBottom: '15px',
    overflow: 'hidden',
});

export const InNetworkContainer = styled('div')({
    color: '#FFF',
    background: PerlmanGreen,
    padding: '15px',
    '& > h1': {
        margin: 'initial',
        fontSize: '30px',
    },
});

export const StyledCrumbs = styled('div')({
    '& h2': {
        margin: '.5em 0',
        fontSize: '1.2rem',
        color: '#444',
        textAlign: 'left',
        letterSpacing: '.1px',
        fontFamily: 'brandon-regular,sans-serif',
    },
    '& h4': {
        margin: '10px 15px',
        fontSize: '1.2rem',
        color: '#666',
        fontFamily: 'brandon-regular,sans-serif',
    },
    '& > p': {
        margin: '0px 0px 15px 30px',
        fontSize: '1.25rem',
    },
});

export const AppointmentButtonContainer = styled('div')(({ theme }) => ({
    [theme.breakpoints.down('md')]: {
        alignItems: 'center',
        justifyContent: 'center',
    },
    '& button': {
        marginRight: '10px',
    },
}));
